function countdown() {
  (typeof window.ss === 'undefined') && (window.ss = {i18n: {_t: (key, str) => str}})

  var tick = function () {
    var o = window.promoTimestamps.end,
      e = window.promoTimestamps.start,
      s = setInterval(function () {
        e += 1000;
        var t = o - e,
          n = Math.floor(t / 864e5),
          a = Math.floor(t % 864e5 / 36e5),
          r = Math.floor(t % 36e5 / 6e4),
          l = Math.floor(t % 6e4 / 1e3),
          targets = [
            {
              els: '#promo__counter',
              fn: (el) => {
                o > e && (el.innerHTML = ss.i18n._t('Countdown.In', 'in') + ' ' + (n ? n + " " + ss.i18n._t('Countdown.Days', 'days').replace(/(s)/, n < 2 ? '' : '$1') + " " : " ") + (a ? a + " " + ss.i18n._t('Countdown.Hours', 'hours') + " " : " ") + (r ? r + " " + ss.i18n._t('Countdown.Minutes', 'minutes') + " " : " ") + l + " " + ss.i18n._t('Countdown.Seconds', 'seconds'))
              }
            },
            {
              els: '.promo__blackfriday--counter',
              fn: (el) => {
                o > e && (el.innerHTML = (
                    "<div class='promo__countdown--digit'>") + n + ("<span class='promo__countdown--timeunder'>" + ss.i18n._t('Countdown.Days', 'days').replace(/(s)/, n === 1 ? '' : '$1') + "</span> </div>" + " : ")
                  + ("<div class='promo__countdown--digit'>" + a + "<span class='promo__countdown--timeunder'>" + ss.i18n._t('Countdown.Hours', 'hours') + "</span></div>" + " : ")
                  + ("<div class='promo__countdown--digit'>" + r + "<span class='promo__countdown--timeunder'>" + ss.i18n._t('Countdown.Minutes', 'minutes') + "</span> </div>" + " : ")
                  + "<div class='promo__countdown--digit'>" + l + "<span class='promo__countdown--timeunder'>" + ss.i18n._t('Countdown.Seconds', 'seconds') + "</span></div>")
              }
            }
          ];

        for (var x = 0; x < targets.length; x++) {
          let els = document.querySelectorAll(targets[x].els);

          for (var y = 0; y < els.length; y++) {
            targets[x].fn(els[y]);
          }
        }

      }, 1e3);
  }

  !window.promoTimestamps && fetch(`/promo/${document.documentElement.lang}/`, {cache: 'no-store'})
    .then(async (response) => {
      window.promoTimestamps = await response.json();
      tick();
    }) || tick();

}

export default countdown;
